<template>
  <div id="address-lookup-form"
       tabindex="0"
       @blur="hideOptions"
  >
    <div class="vx-col w-full">
      <vs-input
          v-model="searchString"
          class="w-full"
          placeholder="Search for an address"
          icon-after
          icon="search"
          @input="lookup"
          @click="lookup"
      >
      </vs-input>
    </div>

    <div
        v-if="showOptions"
        class="vx-col w-full options-col"
    >
      <div class="options-container"
           ref="optionsContainer"
      >
        <div class="address-item"
             v-for="lookupItem in lookupItems"
             @click="selectOption(lookupItem)"
        >
          <span>
          {{ lookupItem.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Loqate from "@/views/components/address/Loqate";
import {debounce} from 'lodash';

export default {
  props: {

  },
  data () {
    return {
      loqateKey: 'PC92-UC95-KX16-GX99',
      lookupString: '',
      lookupItems: [],
      capture: null,
      selectedAddress: [],
      searchString: '',
    }
  },
  created () {
    this.capture = new Loqate(this.loqateKey);
  },
  computed: {
    showOptions() {
      let showOptions = false;

      if (this.lookupItems.length) {
        showOptions = true;
      }

      return showOptions;
    },
  },
  methods: {
    hideOptions(values) {
      if (values.relatedTarget
          && values.relatedTarget.id === 'address-lookup-form'
      ) {
        return;
      }

      this.lookupItems = {};
    },
    async lookup() {
      if (this.searchString.length < 4) {
        return;
      }

      await this.doSearch(this.searchString)
      return false;
    },

    doSearch: debounce( async function(searchString) {
      const { data } = await this.capture.find(searchString);
      this.setDropdownOptions(data.Items);
    }, 250),

    setDropdownOptions(results) {
      this.lookupItems = results.map(({ Id, Description, Text, Type }) => ({
        label: Text + ', ' + Description,
        value: Id,
        type: Type
      }));
    },

    async selectOption(option) {
      this.searchString = (option.label).split(' -')[0];

      if (option.type === 'Address') {
        const { data } = await this.capture.address(option.value);
        this.selectAddress(data.Items[0]);
        this.lookupItems = {};
      } else {
        const { data } = await this.capture.container(option.value);
        this.setDropdownOptions(data.Items);
        this.selectedAddress = {};
      }},
    mapAddress(address) {
      return {
        AddressLine1: address.Line1,
        AddressLine2: address.Line2,
        AddressLine3: address.Line3,
        City: address.City,
        Province: address.Province,
        Region: address.AdminAreaName,
        PostCode: address.PostalCode,
        Country: address.CountryName,
      }
    },
    selectAddress(address) {
      this.$emit('selectAddress', this.mapAddress(address));
    }

  },
}
</script>
<style lang="scss">
#address-lookup-form {
  input {
    &:focus {
      border: 1px solid rgba(0, 0, 0, 0.2) !important;
    }
  }
  i.vs-input--icon {
    top: 11px;
  }

  .options-col {
    position: relative;

    .options-container {
      color: #616161;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-top: 1px solid #f1f1f1;
      border-radius: 0px 0px 5px 5px;
      max-height: 150px;
      overflow-y: auto;
      position: absolute;
      top: -6px;
      z-index: 9;
      width: 100%;
      background: #fff;

      .address-item {
        padding: 5px 19px;

        &:hover {
          color: #000;
          background-color: #f9db2b;
        }
      }
    }
  }
}
  .vs__dropdown-menu {
    padding: 0;
    .vs__no-options {
      display: none;
    }
  }
</style>
